import {
  AlertModalData,
  AlertModalType,
} from '@domgen/dgx-fe-components/modal';

export const mockRegistrationLimitModalData: AlertModalData = {
  title:
    'You have now reached the maximum number of appliances that can be added.',
  gaData: {},
  type: AlertModalType.Info,
  primaryCta: {
    gaAdditionalData: {},
    text: 'Close',
  },
};
